module.exports = __webpack_public_path__ + "static/media/artoimage.0c0c9082.jpg";